import { EnumCacheEntityType } from "@/app/services/generated/enums/enumCacheEntityType.generated";
import type { SalesArea } from "@/app/services/generated/salesareaService";
import { salesAreaService } from "@/app/services/generated/salesareaService";
import {
  EntityWithGuidKeyCache,
  EntityCacheStore,
} from "@/app/caching/apiCache";

export interface IHasSalesAreasCache {
  salesAreas: SalesAreasCache;
}

// Singleton cache store
const salesAreasCacheStore = new EntityCacheStore<SalesArea>(
  EnumCacheEntityType.salesArea,
  async () => salesAreaService.getAllSalesAreas()
);

// Ephemeral reader
export default class SalesAreasCache extends EntityWithGuidKeyCache<SalesArea> {
  constructor() {
    super(salesAreasCacheStore, (x) => x.id);
  }
}
